import { useState, useEffect } from "react";
import { getLaunchContext, canUseGooglePlayBilling, rememberTwaContext } from "@/utils/pwaContext";

/** React hook wrapper around getLaunchContext() - see pwaContext.js for the detection logic. */
export function useLaunchContext() {
  const [context, setContext] = useState(getLaunchContext());
  useEffect(() => {
    setContext(getLaunchContext());
  }, []);
  // Filet de sécurité "zéro prix dans l'app Android" : si le referrer android-app:// a été
  // perdu (reload, restauration, deep link), la seule preuve fiable qu'on tourne dans la TWA
  // Play Store est l'API Digital Goods qui ne se résout QUE dans ce contexte (probe memoïsée,
  // timeout 6s). Dès confirmation, tous les composants gatés basculent en mode "twa".
  useEffect(() => {
    if (context === "twa") return;
    if (typeof window === "undefined" || !("getDigitalGoodsService" in window)) return;
    let cancelled = false;
    canUseGooglePlayBilling().then((ok) => {
      if (ok && !cancelled) {
        rememberTwaContext();
        setContext("twa");
      }
    });
    return () => { cancelled = true; };
  }, [context]);
  return context;
}

export function useIsAndroidApp() {
  return useLaunchContext() === "twa";
}
